import '../App.css';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


export const ContactUs = () => {
    return(
        <Box sx={{marginTop: '15%', display: 'flex', justifyContent: 'center'}}>
            <Paper elevation={3} sx={{width: 'fit-content', padding: '5%'}}>
                <Container sx={{textAlign: 'center', marginInline: 'auto'}}>
                    <Typography variant='h2'>Contact Us</Typography>
                    <Typography variant='body1'>Need assistance or have feedback about B2C Automation Suite? Please contact us at <strong>info@gritsoftwaresystems.com</strong>.</Typography>
                </Container>
            </Paper>
        </Box>
    )
}